import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "bg-white w-full max-w-md rounded-xl shadow-2xl overflow-hidden" };
const _hoisted_2 = { class: "flex items-center justify-between p-6 border-b border-gray-200" };
const _hoisted_3 = { class: "text-xl font-bold text-gray-900" };
const _hoisted_4 = { class: "p-6 space-y-4" };
const _hoisted_5 = { class: "grid grid-cols-3 gap-2" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "text-sm" };
const _hoisted_8 = { class: "flex gap-3 p-6 border-t border-gray-200" };
const _hoisted_9 = ["disabled"];
import { ref, computed, watch } from 'vue';
import { useTheme } from '@shared/composables/useTheme';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TimeSelectionModal',
    props: {
        isOpen: { type: Boolean },
        modelValue: {},
        orderType: {}
    },
    emits: ["update:isOpen", "update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // 🎨 Theme System
        const { theme } = useTheme();
        const selectedTime = ref('');
        // Standard-Zeit berechnen basierend auf aktueller Zeit + Vorbereitung
        const defaultTime = computed(() => {
            const now = new Date();
            const prepTime = props.orderType === 'pickup' ? 20 : 40; // Durchschnittswerte
            const estimatedTime = new Date(now.getTime() + (prepTime * 60 * 1000));
            return `${estimatedTime.getHours().toString().padStart(2, '0')}:${estimatedTime.getMinutes().toString().padStart(2, '0')}`;
        });
        // Einfache Zeit-Optionen generieren - startet mit aktuell ausgewählter Zeit
        const availableTimes = computed(() => {
            // Verwende entweder die bereits ausgewählte Zeit oder die Standard-Zeit vom Backend
            const startTime = props.modelValue.time || defaultTime.value;
            if (!startTime)
                return [];
            const [hour, minute] = startTime.split(':').map(Number);
            const startMinutes = hour * 60 + minute;
            const times = [];
            // 6 Optionen in 15-Minuten-Schritten, beginnend mit der aktuellen/Standard-Zeit
            for (let i = 0; i < 6; i++) {
                const totalMinutes = startMinutes + (i * 15);
                const h = Math.floor(totalMinutes / 60);
                const m = totalMinutes % 60;
                if (h < 21) { // Nur bis 21:00
                    times.push(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`);
                }
            }
            return times;
        });
        function selectTime(time) {
            selectedTime.value = time;
        }
        function closeModal() {
            emit('update:isOpen', false);
        }
        function saveSelection() {
            if (!selectedTime.value)
                return;
            emit('update:modelValue', { time: selectedTime.value });
            closeModal();
        }
        // Standard-Zeit automatisch setzen
        watch(defaultTime, (newTime) => {
            if (newTime && !selectedTime.value && !props.modelValue.time) {
                selectedTime.value = newTime;
            }
        }, { immediate: true });
        // Modal öffnen: existierende Zeit oder Standard setzen
        watch(() => props.isOpen, (isOpen) => {
            if (isOpen) {
                selectedTime.value = props.modelValue.time || defaultTime.value;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                (_ctx.isOpen)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50",
                        onClick: _withModifiers(closeModal, ["self"])
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createCommentVNode(" Header "),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.orderType === 'pickup' ? 'Abholzeit wählen' : 'Lieferzeit wählen'), 1 /* TEXT */),
                                _createElementVNode("button", {
                                    onClick: closeModal,
                                    class: "p-2 text-gray-400 hover:text-gray-600 rounded-full"
                                }, [...(_cache[0] || (_cache[0] = [
                                        _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */)
                                    ]))])
                            ]),
                            _createCommentVNode(" Content "),
                            _createElementVNode("div", _hoisted_4, [
                                _createCommentVNode(" Zeit Auswahl "),
                                _createElementVNode("div", null, [
                                    _cache[1] || (_cache[1] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-3" }, "Zeit auswählen:", -1 /* CACHED */)),
                                    _createElementVNode("div", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTimes.value, (time) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: time,
                                                onClick: ($event) => (selectTime(time)),
                                                class: _normalizeClass(["p-3 text-sm font-medium rounded-lg border transition-all duration-200", selectedTime.value !== time ? 'bg-gray-50 border-gray-200 text-gray-700 hover:opacity-80' : '']),
                                                style: _normalizeStyle(selectedTime.value === time ? {
                                                    backgroundColor: _unref(theme).colors.primary + '20',
                                                    borderColor: _unref(theme).colors.primary,
                                                    color: _unref(theme).colors.primary
                                                } : {})
                                            }, _toDisplayString(time), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_6));
                                        }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                ]),
                                _createCommentVNode(" Ausgewählte Zeit "),
                                (selectedTime.value)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "p-3 border rounded-lg",
                                        style: _normalizeStyle({
                                            backgroundColor: _unref(theme).colors.success + '10',
                                            borderColor: _unref(theme).colors.success + '40',
                                            color: _unref(theme).colors.success
                                        })
                                    }, [
                                        _createElementVNode("p", _hoisted_7, [
                                            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1 /* CACHED */)),
                                            _createTextVNode(" Gewählt: Heute um " + _toDisplayString(selectedTime.value) + " Uhr ", 1 /* TEXT */)
                                        ])
                                    ], 4 /* STYLE */))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _createCommentVNode(" Footer "),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("button", {
                                    onClick: closeModal,
                                    class: "flex-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                                }, " Abbrechen "),
                                _createElementVNode("button", {
                                    onClick: saveSelection,
                                    disabled: !selectedTime.value,
                                    class: "flex-1 px-4 py-2 rounded-lg font-medium text-white transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed hover:opacity-90",
                                    style: _normalizeStyle({
                                        backgroundColor: selectedTime.value ? _unref(theme).colors.primary : '#9ca3af',
                                        borderRadius: _unref(theme).borderRadius
                                    })
                                }, " Speichern ", 12 /* STYLE, PROPS */, _hoisted_9)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
